var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("support " + _vm.themeName)},[_c('section',[_c('Success'),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }